import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'
import { assetPath } from '@/utils/assetPath'
import CircleCheckIcon from '@/icons/circle-check'
import { GlossyButton } from '@/components/shared/atoms/GlossyButton'
import { FadeInUp } from '@/components/shared/atoms/FadeInUp'

export const Route = createFileRoute(
    '/(onboarding)/(auth)/forgot-password/sent'
)({
    validateSearch: (search) => ({
        email: typeof search.email === 'string' ? search.email : '',
    }),
    component: ForgotPasswordEmailSentRoute,
})

function ForgotPasswordEmailSentRoute() {
    const { email } = useSearch({
        from: '/(onboarding)/(auth)/forgot-password/sent',
    })
    const navigate = useNavigate()

    const handleLogin = () => {
        navigate({ to: '/login' })
    }

    return (
        <section className="relative z-10 flex min-h-dvh flex-col pt-safe">
            {/* Logo & Login Button */}
            <div className="flex justify-between px-2 pt-3 md:justify-center">
                <img
                    alt="logo-red"
                    src={assetPath('logo/logo-red.svg')}
                    className="h-[34px] w-[155px] md:mt-12 md:h-[100px] md:w-[440px]"
                />
                <GlossyButton
                    variant="ghost"
                    className="rounded-xl bg-white/25 px-4 py-2.5 backdrop-blur md:fixed md:right-2.5"
                    onClick={handleLogin}
                >
                    Log in
                </GlossyButton>
            </div>

            {/* Heading */}
            <FadeInUp delay={0.3}>
                <div className="px-4 pt-2 pb-6 md:pt-[35vh] md:text-center">
                    <h1 className="font-sfpro text-28 leading-8 font-semibold text-white">
                        Check your inbox
                    </h1>
                </div>
            </FadeInUp>

            {/* Main Content */}
            <div className="flex flex-1 flex-col px-2">
                <FadeInUp delay={0.5}>
                    <div className="flex flex-col items-center text-white">
                        <CircleCheckIcon />
                        <p className="mt-4 text-center text-sm">
                            A link to reset your password has been sent to{' '}
                            {email}
                        </p>
                    </div>
                </FadeInUp>

                <FadeInUp delay={0.7} className="mt-auto mb-6">
                    <div className="pt-6">
                        <GlossyButton
                            className="w-full rounded-xl py-[14px] text-sm"
                            onClick={handleLogin}
                        >
                            Log in
                        </GlossyButton>
                    </div>
                </FadeInUp>
            </div>
        </section>
    )
}
